/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  createDppDocuments,
  createDynamicColumn,
  deleteDppDocuments,
  editDocuments,
  getAcn,
  getDppDocuments,
  getDppDocumentsImage,
  getDppIds,
  getDynamicColumn,
  getItemMaster,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevelsByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocation,
  getSubModulesByRoleId,
  getWarehouses,
  getWarehousesByMovement,
  getZonesByWarehouse,
  uploadForDocuments,
  uploadForUrl,
} from "../../../store";

// Cookies
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import EditButton from "components/standardized-components/EditButton";
import { format } from "date-fns";
import { CSVLink } from "react-csv";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "hidden",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  boxShadow: 24,
  p: 1,
  pt: 3,
  overflow: "hidden",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Documents = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deleteDppDocuments,
  warehouses,
  getDppDocuments,
  getDppDocumentsReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editDocuments,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createDppDocuments,
  uploadForUrl,
  getWarehousesByMovement,
  uploadForDocuments,
  getLevelsByWarehouse,
  getDppIds,
  levelsByWarehouseReducer,
  dppIdSelectedForGlobalFilter,
  getDynamicColumnReducer,
  getDppDocumentsImage,
  getDPPReducer,
  getDppDocumentsImageReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "b3605909-30dc-4c9f-8918-f1ef34354fd2",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "434ae990-b2de-4142-9297-6df24fe43b6f",
      )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "acf6e194-8a3f-4c7f-98b7-9cc2151ed763",
      )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "e1a9e3c5-7896-437b-8b1f-39144248fd07",
      )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "a3048acc-fe87-48ca-a0cd-8d815878faa3",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [updateDocumentSelected, setUpdateDocumentSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const handleChangeDoctype = (selectedData) => {
    setUpdateDocumentSelected(selectedData);
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  // useEffect(() => {
  //   getDppDocuments(dppI jwtToken);
  // }, [ ]);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Doc ID", accessor: "docId" },
      { Header: "DPP code", accessor: "dppCode" },
      { Header: "Document Type", accessor: "docType" },
      { Header: "Version", accessor: "version" },
      { Header: "Issued By", accessor: "issuedBy" },
      {
        Header: "issued Date",
        accessor: "issuedDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value ? format(new Date(value), "dd/MM/yyyy") : "";
        },
      },
      {
        Header: "valid Till",
        accessor: "validTill",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value ? format(new Date(value), "dd/MM/yyyy") : "";
        },
      },
      {
        Header: "file",
        accessor: "file",
        cannotSearch: true,
        cannotSort: true,
      },
      // {
      //   Header: "Valid Till	",

      //   accessor: "cd",
      //   align: "left",
      //   searchType: "date",
      //   Cell: ({ value }) => {
      //     return value
      //       ? format(
      //           addMinutes(
      //             new Date(value),
      //             new Date(value).getTimezoneOffset()
      //           ),
      //           "dd/MM/yyyy hh:mm aaa"
      //         )
      //       : "";
      //   },
      // },

      // { Header: "Created By", accessor: "acnCode" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const headers = [
    { label: "docId", key: "docId" },
    { label: "dppCode", key: "dppCode" },
    { label: "docType", key: "docType" },
    { label: "version", key: "version" },
    { label: "issuedBy", key: "issuedBy" },

    // Date fields
    { label: "issuedDate", key: "createdDate" },
    { label: "validTill", key: "createdDate2" },

    // File field
    // { label: "file", key: "file" },

    // Action (optional)
    // { label: "action", key: "action" }
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "docType", key: "docType" },
    { label: "fileUrl", key: "fileUrl" },
    { label: "version", key: "version" },
    { label: "issuedBy", key: "issuedBy" },
    { label: "issuedDate", key: "issuedDate" },
    { label: "validTill", key: "validTill" },
    { label: "docCategory", key: "docCategory" },
    { label: "orderNo", key: "orderNo" },
  ];
  const csvLink = {
    filename: "Documents List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Documents Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getDppDocumentsReducer.documents.data
      ? getDppDocumentsReducer.documents.data
      : [];
    setPaginationObj(getDppDocumentsReducer?.documents?.pagination);
    setLoading(getDppDocumentsReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.issuedDate);
      const formatDate2 = new Date(item.validTill);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${
          itemDescription ? itemDescription.substring(0, len) : ""
        }`,
        docId: item.docId,
        dppCode: item.dppCode,
        docType: item.docType,
        issuedBy: item.issuedBy,
        version: item.version,
        issuedDate: item.issuedDate,
        validTill: item.validTill,
        file: item.name ? (
          <MDButton
            variant="gradient"
            color="info"
            iconOnly
            size="small"
            style={{ padding: "4px", minWidth: "32px" }}
            onClick={() => handleOpenDocument(item)}
          >
            <Icon>description</Icon>
          </MDButton>
        ) : (
          "-"
        ),
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),

        createdDate2: format(new Date(formatDate2), "dd/MM/yyyy"),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getDppDocumentsReducer]);

  const [currentFile, setCurrentFile] = useState(null);

  const handleOpenDocument = (item) => {
    // Trigger API call
    getDppDocumentsImage(item.moduleName, item.type, item.name, jwtToken);
  };

  // Watch reducer for updates
  useEffect(() => {
    const data = getDppDocumentsImageReducer.documents.data;

    if (data) {
      // Set the file for temporary use
      setCurrentFile(data);

      // Reset local state in reducer copy
      getDppDocumentsImageReducer.documents.data = null; // clears it locally
    }
  }, [getDppDocumentsImageReducer.documents.data]);

  // Optional: automatically clear currentFile after some time
  useEffect(() => {
    if (currentFile) {
      const timer = setTimeout(() => setCurrentFile(null), 1000); // 5 seconds
      return () => clearTimeout(timer);
    }
  }, [currentFile]);

  // Open file whenever currentFile updates
  useEffect(() => {
    if (!currentFile) return;

    let fileUrl;
    if (typeof currentFile === "string") fileUrl = currentFile;
    else if (currentFile.url) fileUrl = currentFile.url;
    else if (currentFile.base64) {
      const byteCharacters = atob(currentFile.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: currentFile.type || "application/octet-stream",
      });
      fileUrl = URL.createObjectURL(blob);
    } else return;

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }, [currentFile]);

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    [],
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setZoneIdSelected("");

    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});

    setdppIdSelected("");
    formik.setValues(initialValues);
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const activeDataOptions = [
    { label: "User Manual", value: "User Manual" },
    { label: "Safety Certificate", value: "Safety Certificate" },
    { label: "Warranty Document", value: "Warranty Document" },
    { label: "Compliance Certificate", value: "Compliance Certificate" },
    { label: "Technical specification", value: "Technical specification" },
    {
      label: "Verified Carbon Declaration",
      value: "Verified Carbon Declaration",
    },
  ];

  const activeDataOptionsIndustryId = [
    { label: "GOTS", value: "GOTS" },
    { label: "Textile Test Report", value: "Textile Test Report" },
    {
      label: "Supplier Sustainability Certificate",
      value: "Supplier Sustainability Certificate",
    },
    {
      label: "Active Supplier Certifications Ledger",
      value: "Active Supplier Certifications Ledger",
    },
    {
      label: "Supplier Social Compliance Audit Report ",
      value: "Supplier Social Compliance Audit Report ",
    },
    { label: "GRS", value: "GRS" },
    { label: "OEKO-TEX", value: "OEKO-TEX" },
  ];

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName,
  );

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  const initialValues = {
    DPPID: "",
    DocumentType: "",
    FileURL: "",
    Version: "",
    IssuedBy: "",
    IssuedDate: "",
    ValidTill: "",
    // rackName: "",
    // bin: "",
  };

  const today = new Date().toISOString().split("T")[0];
  const validationSchema = Yup.object({
    DocumentType: Yup.object().required(" "),

    Version: Yup.string().required(" "),
    IssuedBy: Yup.string().required(" "),
    IssuedDate: Yup.date()
      .required(" ")
      .max(today, "Issued Date cannot be a future date"),

    ValidTill: Yup.date()
      .required(" ")
      .min(today, "Valid Till cannot be a past date"),
  });

  const [dppIdSelected, setdppIdSelected] = useState("");

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter) {
      setdppIdSelected(dppIdSelectedForGlobalFilter);
    }
  }, [dppIdSelectedForGlobalFilter]);

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getDppDocuments(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getDppDocuments(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const [dppOptions, setDPPOptions] = useState([]);
  const [selectedIndustryId, setSelectedIndustryId] = useState(null);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];

    data.forEach((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
        industryId: zone.industryId,
        industryName: zone.industryName,
      });
    });

    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const handleChangeDpp = (selectedOption) => {
    setSelectedIndustryId(selectedOption?.industryId || null);
    setdppIdSelected(selectedOption);
    setWarehouseIdSelected("");

    formik.setFieldValue("dppId", selectedOption);
  };
  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const handleChangeDppForUpdate = (selectedData) => {
    setdppIdForUpdateSelected(selectedData);
  };
  useEffect(() => {
    getDppIds(jwtToken);
  }, []);

  // console.log("dppIdSelectedForGlobalFilter?.industryId", dppIdSelectedForGlobalFilter?.industryId)
  const documentOptions =
    selectedIndustryId === 1 || dppIdSelectedForGlobalFilter?.industryId === 1
      ? activeDataOptionsIndustryId
      : activeDataOptions;

  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");
  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");

    const formData = new FormData();

    formData.append("cdBy", userId);
    formData.append("dppId", dppIdSelected?.value);
    formData.append("docType", warehouseIdSelected?.value);
    formData.append("fileUrl", values.FileURL); // keep if backend expects it
    formData.append("version", values.Version);
    formData.append("issuedBy", values.IssuedBy);
    formData.append("issuedDate", values.IssuedDate);
    formData.append("validTill", values.ValidTill);
    formData.append("documentType", "technicalDocumentsImage");
    formData.append("moduleName", "technicalDocuments");

    // ✅ attach uploaded document
    if (values.file) {
      formData.append("attachments", values.file);
    }

    let res = await createDppDocuments(formData, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getDppDocuments(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});

      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setZoneIdSelected("");
      setSectionIdSelected("");
      setRackIdSelected("");
      setLocationIdSelected("");

      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    } else {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("Create");
      setIsErrorAllocateItem(true);
    }

    setSelectedItemCode("");
    setSelectedZoneName("");
    setSelectedBin("");
    // resetForm();
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let docId = singleDataForDelete.docId;
    // let userId = singleDataForDelete.userId;

    let res = await deleteDppDocuments(docId);

    if (res.status) {
      getDppDocuments(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getDppDocuments(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {
    setUpdateDocumentSelected({
      label: singleData.docType,
      value: singleData.docType,
      value: singleData.dppId,
      industryId: singleData.industryId,
    });
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };

  //  dppId:values.DPPID,
  //    docType:warehouseIdSelected?.value,
  //   fileUrl:values.FileURL,
  //   version:values.Version,
  //   issuedBy:values.IssuedBy,
  //   issuedDate:values.IssuedDate,
  //   validTill:values.ValidTill

  const initialValueForUpdate = {
    DPPID: singleFgDataForUpdate.dppCode,
    FileURL: singleFgDataForUpdate.fileUrl,
    Version: singleFgDataForUpdate.version,
    IssuedBy: singleFgDataForUpdate.version,
    IssuedDate: singleFgDataForUpdate.issuedDate
      ? (() => {
          const [month, day, year] =
            singleFgDataForUpdate.issuedDate.split("/");
          return `${year}-${month}-${day}`;
        })()
      : "",

    ValidTill: singleFgDataForUpdate.validTill
      ? (() => {
          const [month, day, year] = singleFgDataForUpdate.validTill.split("/");
          return `${year}-${month}-${day}`;
        })()
      : "",
  };

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Update");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");

    const formData = new FormData();

    formData.append("udBy", userId);
    formData.append("docId", String(singleFgDataForUpdate?.docId ?? ""));
    formData.append("dppId", values.DPPID);
    formData.append("docType", updateDocumentSelected?.value);
    formData.append("version", values.Version);
    formData.append("issuedBy", values.IssuedBy);
    formData.append("issuedDate", values.IssuedDate);
    formData.append("validTill", values.ValidTill);
    formData.append("documentType", "technicalDocumentsImage");
    formData.append("moduleName", "technicalDocuments");

    // ✅ attach new document only if selected
    if (values.file) {
      formData.append("attachments", values.file);
    }

    let res = await editDocuments(formData, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getDppDocuments(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getDppDocuments(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("file", uploadCsvData);

    let res = await uploadForDocuments(data);

    if (res.status) {
      getDppDocuments(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }

    if (!res.status) {
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const subModuleId = "b3605909-30dc-4c9f-8918-f1ef34354fd2";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);

  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getDppDocuments(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [isUploading, setIsUploading] = useState(false);

  const uploadDocumentHandler = async () => {
    if (!formik.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    // 🔑 MUST match Postman keys
    data.append("File", formik.values.file); // file
    data.append("module_name", "technical_documents"); // text

    try {
      const res = await uploadForUrl(data, jwtToken);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill File URL
        formik.setFieldValue("FileURL", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      console.error(error);
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  const uploadDocumentHandlerForUpdate = async () => {
    if (!formikForUpdate.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    // 🔑 Must match Postman keys

    // 🔑 MUST match Postman keys
    data.append("File", formikForUpdate.values.file); // file
    data.append("module_name", "technical_documents");

    try {
      const res = await uploadForUrl(data);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill Proof Document URL
        formikForUpdate.setFieldValue("FileURL", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      console.error(error);
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  const hideProductImageUrl = true;
  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4}>
                {allocateAccess && (
                  <Tooltip>
                    <CreateButton
                      tooltip="Add Documents "
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleAllocateItemModal();
                        getWarehouses(jwtToken);
                        getItemMaster(jwtToken);
                        getAcn(jwtToken);
                        getRelationLocation(jwtToken);
                      }}
                      style={{ borderRadius: "5px" }}
                      size="small"
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </Tooltip>
                )}
                <CSVLink {...csvLink}>
                  <DownloadDataButton
                    tooltip="Download Documents List"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink>

                {/* <Tooltip title="Upload CSV">
                    <MDButton
                      style={{ marginLeft: "1rem" }}
                      // disabled={!uploadItem}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </MDButton>
                  </Tooltip> */}
              </MDBox>
            </MDBox>

            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {/* {loadingForDynamicColumn && ( */}
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                showTotalEntries={true}
                noEndBorder
                options={{ draggable: false }}
                // serverSidePagination={true}
                // paginationObj={paginationObj}
                // pageNoValue={pageNo}
                // rowsPerPageValue={rowsPerPage}
                // pageNoProp={importPageNo}
                // rowsPerPageProp={importRowsPerPage}
                // searchProp={importSearch}
                loading={loading}
                hideColumns={hiddenColumsDetails}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
              />
              {/* )} */}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={6}>
                          <MDBox>
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Document Type{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Choose one..."
                              name="DocumentType"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "DocumentType" },
                                });
                              }}
                              value={updateDocumentSelected}
                              options={activeDataOptions}
                              onChange={(selectedOption) => {
                                handleChangeDoctype(selectedOption);
                                getZonesByWarehouse(selectedOption?.value);
                                formikForUpdate.setFieldValue(
                                  "DocumentType",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForUpdate.touched.DocumentType &&
                              formikForUpdate.errors.DocumentType && (
                                <TextError
                                  msg={formikForUpdate.errors.DocumentType}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6" fontWeight={500}>
                              Upload Document
                            </MDTypography>

                            <MDBox
                              display="flex"
                              alignItems="center"
                              width="100%"
                              gap={1}
                            >
                              {/* Hidden file input */}
                              <input
                                id="upload-file"
                                type="file"
                                hidden
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];
                                  formikForUpdate.setFieldValue("file", file);
                                }}
                              />

                              {/* Choose File */}
                              <label htmlFor="upload-file">
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                >
                                  Choose File
                                </MDButton>
                              </label>

                              {/* File name – takes remaining width */}
                              <MDBox
                                flex={1}
                                px={2}
                                py={1}
                                sx={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  backgroundColor: "#fafafa",
                                }}
                              >
                                <MDTypography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  title={formikForUpdate.values.file?.name}
                                >
                                  {formikForUpdate.values.file?.name ??
                                    singleFgDataForUpdate?.name ??
                                    "Not Available"}
                                </MDTypography>
                              </MDBox>

                              {/* Upload button */}
                              {/* <MDButton
        variant="contained"
        color="success"
        disabled={!formikForUpdate.values.file || isUploading}
        onClick={uploadDocumentHandlerForUpdate}
      >
        {isUploading ? "Uploading..." : "Upload"}
      </MDButton> */}
                            </MDBox>
                          </MDBox>
                        </Grid>

                        {!hideProductImageUrl && (
                          <Grid item xs={12} lg={12}>
                            <MDBox>
                              <MDTypography variant="h6">File URL</MDTypography>
                              <MDInput
                                type="text"
                                name="FileURL"
                                fullWidth
                                autoComplete="off"
                                onBlur={formikForUpdate.handleBlur}
                                onChange={formikForUpdate.handleChange}
                                value={formikForUpdate.values.FileURL}
                                error={
                                  formikForUpdate.touched.FileURL &&
                                  formikForUpdate.errors.FileURL &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "10px",
                                  },
                                  maxLength: 45,
                                }}
                              />
                              {formikForUpdate.touched.FileURL &&
                                formikForUpdate.errors.FileURL && (
                                  <TextError
                                    msg={formikForUpdate.errors.FileURL}
                                  />
                                )}
                            </MDBox>
                          </Grid>
                        )}
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">Version</MDTypography>
                            <MDInput
                              type="text"
                              name="Version"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Version}
                              error={
                                formikForUpdate.touched.Version &&
                                formikForUpdate.errors.Version &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Version &&
                              formikForUpdate.errors.Version && (
                                <TextError
                                  msg={formikForUpdate.errors.Version}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">Issued By</MDTypography>
                            <MDInput
                              type="text"
                              name="IssuedBy"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.IssuedBy}
                              error={
                                formikForUpdate.touched.IssuedBy &&
                                formikForUpdate.errors.IssuedBy &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.IssuedBy &&
                              formikForUpdate.errors.IssuedBy && (
                                <TextError
                                  msg={formikForUpdate.errors.IssuedBy}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">
                              Issued Date
                            </MDTypography>
                            <MDInput
                              type="date"
                              name="IssuedDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.IssuedDate}
                              error={
                                formikForUpdate.touched.IssuedDate &&
                                formikForUpdate.errors.IssuedDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.IssuedDate &&
                              formikForUpdate.errors.IssuedDate && (
                                <TextError
                                  msg={formikForUpdate.errors.IssuedDate}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">Valid Till</MDTypography>
                            <MDInput
                              type="date"
                              name="ValidTill"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ValidTill}
                              error={
                                formikForUpdate.touched.ValidTill &&
                                formikForUpdate.errors.ValidTill &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ValidTill &&
                              formikForUpdate.errors.ValidTill && (
                                <TextError
                                  msg={formikForUpdate.errors.ValidTill}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => setIsSuccessForUpdate(false)}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Documents Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>
                        {/* <MDBox mt={3} ml={10}> */}

                        {/* <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton> */}

                        {/* Submit Button */}
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Technical Document
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginRight: "10px",
                            marginTop: "4px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            DPP Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DPPID" },
                              });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox ml={1} mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Document Type{" "}
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="DocumentType"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DocumentType" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={documentOptions}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "DocumentType",
                                selectedOption,
                              );
                            }}
                          />
                          {formik.touched.DocumentType &&
                            formik.errors.DocumentType && (
                              <TextError msg={formik.errors.DocumentType} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} mt={1}>
                        <MDBox mb={1}>
                          <MDTypography variant="h6" fontWeight={500}>
                            Upload Document
                          </MDTypography>

                          <MDBox
                            display="flex"
                            alignItems="center"
                            width="100%"
                            gap={1}
                          >
                            {/* Hidden file input */}
                            <input
                              id="upload-file"
                              type="file"
                              hidden
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                formik.setFieldValue("file", file);
                              }}
                            />

                            {/* Choose File */}
                            <label htmlFor="upload-file">
                              <MDButton
                                variant="outlined"
                                component="span"
                                color="info"
                              >
                                Choose File
                              </MDButton>
                            </label>

                            {/* File name – takes remaining width */}
                            <MDBox
                              flex={1}
                              px={2}
                              py={1}
                              sx={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                backgroundColor: "#fafafa",
                              }}
                            >
                              <MDTypography
                                variant="body2"
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={formik.values.file?.name}
                              >
                                {formik.values.file?.name || "No file selected"}
                              </MDTypography>
                            </MDBox>

                            {/* Upload button */}
                            {/* <MDButton
        variant="contained"
        color="success"
        disabled={!formik.values.file || isUploading}
        onClick={uploadDocumentHandler}
      >
        {isUploading ? "Uploading..." : "Upload"}
      </MDButton> */}
                          </MDBox>
                        </MDBox>
                      </Grid>

                      {!hideProductImageUrl && (
                        <Grid item xs={12} lg={12}>
                          <MDBox mb={2}>
                            <MDTypography variant="h6">File URL</MDTypography>
                            <MDInput
                              type="text"
                              name="FileURL"
                              fullWidth
                              autoComplete="off"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.FileURL}
                              error={
                                formik.touched.FileURL &&
                                formik.errors.FileURL &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formik.touched.FileURL &&
                              formik.errors.FileURL && (
                                <TextError msg={formik.errors.FileURL} />
                              )}
                          </MDBox>
                        </Grid>
                      )}
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox mb={1}>
                          <MDTypography variant="h6">Version</MDTypography>
                          <MDInput
                            type="text"
                            name="Version"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Version}
                            error={
                              formik.touched.Version &&
                              formik.errors.Version &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Version && formik.errors.Version && (
                            <TextError msg={formik.errors.Version} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox ml={1} mb={1}>
                          <MDTypography variant="h6">Issued By</MDTypography>
                          <MDInput
                            type="text"
                            name="IssuedBy"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.IssuedBy}
                            error={
                              formik.touched.IssuedBy &&
                              formik.errors.IssuedBy &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.IssuedBy &&
                            formik.errors.IssuedBy && (
                              <TextError msg={formik.errors.IssuedBy} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Issued Date</MDTypography>
                          <MDInput
                            type="date"
                            name="IssuedDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.IssuedDate}
                            error={
                              formik.touched.IssuedDate &&
                              formik.errors.IssuedDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              max: today, // Cannot select future date
                            }}
                          />
                          {formik.touched.IssuedDate &&
                            formik.errors.IssuedDate && (
                              <TextError msg={formik.errors.IssuedDate} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6} mt={1}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography variant="h6">Valid Till</MDTypography>
                          <MDInput
                            type="date"
                            name="ValidTill"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ValidTill}
                            error={
                              formik.touched.ValidTill &&
                              formik.errors.ValidTill &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              min: today, // Cannot select past date
                            }}
                          />
                          {formik.touched.ValidTill &&
                            formik.errors.ValidTill && (
                              <TextError msg={formik.errors.ValidTill} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "1px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={
                          !formik.isValid ||
                          allocateButtonName === "Please wait..."
                        }
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getDppDocumentsReducer: state.getDppDocumentsReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDPPReducer: state.getDPPReducer,
    getDppDocumentsImageReducer: state.getDppDocumentsImageReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getDppDocuments: (dppId, jwtToken) =>
      dispatch(getDppDocuments(dppId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createDppDocuments: (payload, jwtToken) =>
      dispatch(createDppDocuments(payload, jwtToken)),
    uploadForUrl: (payload, jwtToken) =>
      dispatch(uploadForUrl(payload, jwtToken)),
    deleteDppDocuments: (docId, jwtToken) =>
      dispatch(deleteDppDocuments(docId, jwtToken)),
    uploadForDocuments: (payload, jwtToken) =>
      dispatch(uploadForDocuments(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editDocuments: (payload, jwtToken) =>
      dispatch(editDocuments(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getDppDocumentsImage: (moduleName, type, name, jwtToken) =>
      dispatch(getDppDocumentsImage(moduleName, type, name, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),

    getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Documents);
